(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pill-wysylka"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__wpxPillInit) { window.__wpxPillInit(); return; }

  var DOW = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var FMT = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Warsaw',
    hourCycle: 'h23',
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  function warsawNow() {
    var p = {};
    FMT.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {
      date: p.year + '-' + p.month + '-' + p.day,
      dow: DOW[p.weekday],
      sec: (parseInt(p.hour, 10) % 24) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10)
    };
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function buildDigits(out) {
    out.innerHTML =
      '<span class="wpx-d"></span><span class="wpx-d"></span><span>:</span>' +
      '<span class="wpx-d"></span><span class="wpx-d"></span><span>:</span>' +
      '<span class="wpx-d"></span><span class="wpx-d"></span>';
    return Array.prototype.slice.call(out.querySelectorAll('.wpx-d'));
  }

  function render(cfg, h, m, s) {
    var str = pad(h) + pad(m) + pad(s);
    for (var i = 0; i < 6; i++) {
      var el = cfg.digits[i];
      if (el.textContent === str[i]) { continue; }
      el.textContent = str[i];
      if (cfg.anim && !cfg.first && !REDUCED && el.animate) {
        el.animate(
          [
            { transform: 'translateY(0.55em)', opacity: 0 },
            { transform: 'translateY(0)', opacity: 1 }
          ],
          { duration: 260, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)' }
        );
      }
    }
    cfg.first = false;
  }

  function tick(el) {
    var cfg = el.__wpx;
    var now = warsawNow();
    var left = cfg.cutoff - now.sec;

    var open =
      cfg.days.indexOf(now.dow) !== -1 &&
      cfg.holidays.indexOf(now.date) === -1 &&
      left > 0;

    var design = window.Shopify && window.Shopify.designMode;

    if (!open && !design) { el.hidden = true; return; }
    if (left <= 0) { left += 86400; }

    render(cfg, Math.floor(left / 3600), Math.floor((left % 3600) / 60), left % 60);
    if (el.hidden) { el.hidden = false; }
  }

  function init() {
    document.querySelectorAll('[data-wpx-pill]').forEach(function (el) {
      if (el.__wpxTimer) { clearInterval(el.__wpxTimer); }
      var cut = (el.getAttribute('data-cutoff') || '15:00').split(':');
      var out = el.querySelector('.wpx-pill__time');
      el.__wpx = {
        cutoff: (parseInt(cut[0], 10) || 0) * 3600 + (parseInt(cut[1], 10) || 0) * 60,
        days: (el.getAttribute('data-days') || '1,2,3,4,5').split(/[^0-9]+/).filter(Boolean).map(Number),
        holidays: (el.getAttribute('data-holidays') || '').split(/[^0-9-]+/).filter(Boolean),
        anim: el.getAttribute('data-digits') === '1',
        digits: buildDigits(out),
        first: true
      };
      tick(el);
      el.__wpxTimer = setInterval(function () { tick(el); }, 1000);
    });
  }

  window.__wpxPillInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
  } catch(e) { console.error(e); }
})();

})();
